(() => {
  document.querySelectorAll('[data-fab-app-demo]').forEach((demo) => {
    const tabs = [...demo.querySelectorAll('[data-app-tab]')];
    const screens = [...demo.querySelectorAll('[data-app-screen]')];

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
        screens.forEach((screen) => {
          const active = screen.dataset.appScreen === tab.dataset.appTab;
          screen.hidden = !active;
          screen.classList.toggle('is-active', active);
        });
      });
    });
  });
})();
